export default __webpack_public_path__ + "static/media/star-full.adf458a0.svg";